export default __webpack_public_path__ + "0b43a19e26435020f1d816ac82784363.png";